module.exports = __webpack_public_path__ + "static/image 123-87d1c7646247d5ba6bb241e4849003c0.jpg";